'use strict';

var util = require('../util/property-util');
var arrayUtil = require('../util/array-util');

module.exports = /*@ngInject*/ function TrainScheduleFactory() {
    var factory = {
        setTime: setTime,
        getTrainIndex: getTrainIndex,
        getTrainById: getTrainById,
        getWaypointAbbreviationById: getWaypointAbbreviationById,
        getWaypointByAbbreviation: getWaypointByAbbreviation,
        parseDatabaseTimetable: parseDatabaseTimetable,
        parseTimeString:parseTimeString
    };

    return factory;

    /*
     FUNCTIONS
     */

    function setTime(newDate, time) {
        var date = new Date(newDate.getTime());
        date.setHours(time.getHours());
        date.setMinutes(time.getMinutes());
        date.setSeconds(0);
        date.setMilliseconds(0);

        return date;
    }


    function getTrainIndex(trainId, trains) {
        for (var i = 0; i < trains.length; i++) {
            if (trains[i].relativeId === trainId) {
                return i;
            }
        }
    }

    function getTrainById(trains, id) {
        return arrayUtil.getFirstInList(trains, "relativeId", id);
    }

    function getWaypointByAbbreviation(abr, waypoints) {
        var found = undefined;
        waypoints.some(function (entry) {
            if (entry.abbreviation === abr) {
                found = entry;
                return true;
            }
        });

        return found;
    }

    function getWaypointAbbreviationById(id, waypoints) {
        var waypoint = arrayUtil.getFirstInList(waypoints, "id", id);

        if(util.isDefined(waypoint)){
            return waypoint.abbreviation;
        }
    }

    function parseDatabaseTimetable(timetable, waypoints) {
        timetable.forEach(function (entry) {
            if(angular.isNumber(entry.startStation)){
                entry.startStation = getWaypointAbbreviationById(entry.startStation, waypoints);
            }
            if(angular.isNumber(entry.endStation)) {
                entry.endStation = getWaypointAbbreviationById(entry.endStation, waypoints);
            }
        });
        return timetable;
    }

    function parseTimeString(string) {
        var date = new Date(0);
        var time = string.split(":");
        date.setHours(time[0]);
        date.setMinutes(time[1]);
        date.setSeconds(0);
        date.setMilliseconds(0);
        return date;
    }
};